export const HOTELS_CACHE_VERSION = 5;
export const COMMON_CACHE_VERSION = 6;
